export const ShowSnackbar = (text: string, buttonText: string, delay: number, onClick:any|undefined=undefined) => {

    let timer: string | number | NodeJS.Timeout | null | undefined = null;

    // Removing any old snackbar
    const old = document.querySelectorAll('.snackbar');
    if(old.length > 0)
        for (let i = 0; i < old.length; i++)
            old[i].remove();

    const b = document.body;
    const snackbar = document.createElement('div');
    snackbar.classList.add('snackbar');
    const span = document.createElement('span');
    span.classList.add('f-roboto');
    span.innerText = text;
    const btn = document.createElement('button')
    btn.innerText = buttonText;

    const hideSnackbar = () => {
        if(timer !== null)
            clearTimeout(timer);
        snackbar.remove();
    };

    btn.addEventListener('click',()=> {
        if(typeof onClick !== 'undefined')
            onClick();
        hideSnackbar();
    });

    snackbar.append(span,btn);
    b.append(snackbar);

    setTimeout(()=>snackbar.classList.add('active'),100);

    // Close after n milliseconds.
    timer = setTimeout(hideSnackbar,delay);
};